module.exports = __webpack_public_path__ + "static/media/filename (22).7e9516e0.png";